import { Box, Circle, Flex, HStack, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import LoadingIndicator from "@components/Loading";
import NotificationsSidebar from "@components/NotificationsSidebar";
import BellIcon from "@components/icons/BellIcon";
import { useNotifications } from "@api/hooks";

interface Props {
	id?: string;
	children?: React.ReactNode;
	loading?: boolean;
	showNotifications?: boolean;
}

export const PageTitle: React.FC<Props> = ({ id, children, loading, showNotifications }) => {
	const [isNotificationsVisible, setIsNotificationsVisible] = useState(false);

	const { data } = useNotifications(!!showNotifications);

	const hasUnread = useMemo(() => {
		return (data?.notifications || []).some((notif: any) => notif.status === "NEW");
	}, [data?.notifications]);

	return (
		<>
			<Flex
				id={id}
				justifyContent={"space-between"}
				alignItems={"center"}
				flexDir={"row"}
				w="full"
				borderBottomWidth="1px"
				borderBottomColor={"divider"}
				borderBottomStyle={"solid"}
			>
				<HStack>
					<Text fontSize={"2xl"} fontWeight={"semibold"} as="h1">
						{children}
					</Text>
					{loading && <LoadingIndicator className="loading" size={"s"} />}
				</HStack>
				{showNotifications && (
					<Tooltip label="Notifikationer" openDelay={350}>
						<Box pos={"relative"}>
							<IconButton
								icon={<BellIcon />}
								aria-label="Notifications"
								bg="white"
								onClick={() => setIsNotificationsVisible((prev) => !prev)}
							/>
							{hasUnread && (
								<Circle
									bg="red.500"
									size={"3"}
									borderWidth={"2px"}
									borderColor="white"
									pos="absolute"
									top="1.5"
									right="6px"
								/>
							)}
						</Box>
					</Tooltip>
				)}
			</Flex>
			{isNotificationsVisible && <NotificationsSidebar onBack={() => setIsNotificationsVisible((prev) => !prev)} />}
		</>
	);
};
